




















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import setting from '@/core/setting'
import { userName } from '@/utils/regExp'
let timer: any = ''
import YunYing from '../YunYing.vue'
import cloneDeep from 'lodash/cloneDeep'
import AuthApi from '@/api/auth'
const DD_APP_ID = 'dingmb9wmymfxvewbtts'
@Component({
	name: 'login',
	components: { YunYing },
})
export default class Login extends Vue {
	private verifyURL: string = ''
	private showYunYing: boolean = false
	private form: any = {}
	private loading: boolean = false
	private ldapForm: any = {}
	private ldapLoading: boolean = false
	private requireVerifyCode: boolean = false
	private userName: any = userName
	private txt: any = '获取验证码'
	private disabled: boolean = false
	private message: string = ''
	private formData: any = ''

	private activeKey: string = '1'
	private switchData: any = {}

	private created() {
		this.form = this.$form.createForm(this)
		this.ldapForm = this.$form.createForm(this)
		this.setSwitch()
	}

	private get mobile() {
		const mobile = this.$store.getters.userInfo.mobile.split('')
		for (let i = 3; i < 7; i++) {
			mobile[i] = '*'
		}
		return mobile.join('')
	}

	// 统一认证平台开关
	private setSwitch() {
		AuthApi.setSwitch({})
			.then((res: any) => {
				this.switchData = res.data
			})
			.finally(() => {})
	}

	private getVerifyImage() {
		this.verifyURL =
			process.env.VUE_APP_API_KEY + 'injury/user/verifyCode?' + Math.random()
	}

	private onOk(form: any) {
		this.doLogin(form, '')
	}

	private async doLogin(values: any, type: string) {
		if (type == 'ldap') {
			this.ldapLoading = true
		} else {
			this.showYunYing = false
			this.loading = true
		}

		try {
			const copy = cloneDeep(values)
			let res: any = {}
			if (type == 'ldap') {
				res = await this.$store.dispatch('user/ldapLogin', copy)
			} else {
				res = await this.$store.dispatch('user/Login', copy)
			}

			if (res.code === 409) {
				this.formData = values
				this.message = res.message
				this.showYunYing = true
			} else {
				await this.$store.dispatch('user/getUserInfo')
				this.$router.replace(
					'/',
					() => {},
					() => {}
				) // 防报错 TODO
				this.$nextTick(() => {
					setTimeout(() => {
						if (res.data.validateDay <= 30 && res.data.validateDay > 0) {
							this.$confirm({
								title: '提示',
								content: `您的登录密码还有${res.data.validateDay}天过期，请注意定期修改密码，确保账号安全！`,
								onOk: () => {
									this.$router.push('/Settings/Password')
								},
							})
						} else if (res.data.validateDay <= 0) {
							this.$confirm({
								title: '提示',
								content: `您的登录密码已到期，请尽快修改`,
								onOk: () => {
									this.$router.push('/Settings/Password')
								},
							})
						}
					}, 1000)
				})
			}
		} catch (e) {
			if (e.code === 420) {
				this.requireVerifyCode = true
			}
			this.getVerifyImage()
		} finally {
			setTimeout(() => {
				if (type == 'ldap') {
					this.ldapLoading = false
				} else {
					this.loading = false
				}
			}, 500)
		}
	}

	private handleLoginSubmit(e: any) {
		e.preventDefault()
		if (this.loading) {
			return
		}
		this.form.validateFields(async (error: any, values: any) => {
			if (!error) {
				this.doLogin(values, '')
			}
		})
	}
	private ldapLoginSubmit(e: any) {
		e.preventDefault()
		if (this.ldapLoading) {
			return
		}
		this.ldapForm.validateFields(async (error: any, values: any) => {
			if (!error) {
				this.doLogin(values, 'ldap')
			}
		})
	}
	private tabsChange(e: any) {
		this.activeKey = e
		if (e == '3') {
			this.getDing()
		}
	}
	private getDing() {
		const res = {
			appid: DD_APP_ID,
			redirect_uri: `${location.origin}/ddJump`,
		}
		// @ts-ignore
		window.DTFrameLogin(
			{
				id: 'dd-qrcode',
				width: 300,
				height: 300,
			},
			{
				redirect_uri: encodeURIComponent(res.redirect_uri),
				client_id: res.appid,
				scope: 'snsapi_login',
				response_type: 'code',
				state: 'STATE',
				prompt: 'consent',
			},
			(loginResult: any) => {
				const { redirectUrl, authCode, state } = loginResult
				this.$router.replace({
					path: '/ddJump',
					query: {
						redirectUrl,
						authCode,
						state,
					},
				})
			},
			(errorMsg: any) => {
				// 这里一般需要展示登录失败的具体原因
				alert(`Login Error: ${errorMsg}`)
			}
		)
	}
}
